import { CommonModule } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ResizeObserverModule } from '@ng-web-apis/resize-observer';
import { ComponentsModule } from '@components/components.module';
import { CarsCustomerService } from '@customers/services/cars.customer.service';
import { PaymentCustomerService } from '@customers/services/payment.customer.service';
import { ProfileCustomerService } from '@customers/services/profile.customer.service';
import { RequestsCustomerService } from '@customers/services/requests.customer.service';
import { SharedCustomerService } from '@customers/services/shared.customer.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CarCustomerService } from '@parts-catalog/services/cars.customer.service';
import { CatalogsCustomerService } from '@parts-catalog/services/catalogs.customer.service';
import { WatchStorageService } from '@parts-catalog/services/watchstorage.service';
import { ModalConfirmationComponent } from '@reusable/components/common/modals/modal-confirmation/modal-confirmation.component';
import { ModalComponent } from '@reusable/components/common/modals/modal/modal.component';
import { TabComponent } from '@reusable/components/common/tabs/tab/tab.component';
import { TabsComponent } from '@reusable/components/common/tabs/tabs/tabs.component';
import { DisableControlDirective } from '@reusable/directives/disable-control/disable-control.directive';
// import { errorHandlerFactory } from '@reusable/services/app.error-handler';

import { SharedFormResetService } from '@reusable/services/form-reset.service';
import { S3Uploader } from '@reusable/services/helpers/uploader.service';
import { QuickTranslateService } from '@reusable/services/quick-translate.service';
import { UsersService } from '@reusable/services/users/users.service';
import { ValidateVinService } from '@reusable/services/validate-vin';
import { AddCustomerUserComponent } from '@reusable/shared/add-customer/add-customer.component';
import { VendorRegistrationComponent } from '@reusable/shared/vendor-registration/vendor-registration.component';
import { TeamCoreManufacturesService } from '@team/services/core/cars/manufactures.team.service';
import { TeamCoreModelsService } from '@team/services/core/cars/models.team.service';
import { TeamCoreCategoriesService } from '@team/services/core/inventory/categories.team.service';
import { TeamCorePartsService } from '@team/services/core/inventory/parts.team.service';
import { TeamCoreBrandsService } from '@team/services/core/miscellanious/brands.team.service';
import { FormResetService } from '@team/services/form-reset.service';
import { LookupService } from '@team/services/lookup.service';
import { TeamUsersService } from '@team/services/users/agent.users.team.service';
import { ToastrModule } from 'ngx-toastr';
import { FocusDirective } from '../directives/focus/focus.directive';
import { ContentService } from '../services/common/content.service';
import { AlgoliaSearchService } from './../services/algolia.service';
import { AboutUsComponent } from './about-us/about-us.component';
import { AddCarComponent } from './add-car/add-car.component';
import { AlgoliaSelectorComponent } from './algolia-selector/algolia-selector.component';
import { CartComponent } from './cart/cart.component';
import { CatalogNavigationBoxComponent } from './catalog-navigation-box/catalog-navigation-box.component';
import { CatalogSearchBoxComponent } from './catalog-search-box/catalog-search-box.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { CustomFooterComponent } from './custom-footer/custom-footer.component';
import { EditCustomerCarComponent } from './edit-customer-car/edit-customer-car.component';
import { FAQComponent } from './faq/faq.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { ManualDispatchComponent } from './manual-dispatch/manual-dispatch.component';
import { FormatTimePipe, MobileLoginComponent } from './mobile-login/mobile-login.component';
import { StoreNewRequestComponent } from './new-request/new-request.component';
import { SharedAuthComponent } from './shared-auth/shared-auth.component';
import { sharedModuleRoutes } from './shared-module.routes';
import { ViewDoShipmentDetailsComponent } from './view-do-shipment-details/view-do-shipment-details.component';
import { WorkshopsApplicationComponent } from './workshops-application/workshops-application.component';
import { ScrollbarComponent } from './scrollbar/scrollbar.component';

import { DndModule } from 'ngx-drag-drop';
import { AgGridModule } from 'ag-grid-angular';
import { NG_EVENT_PLUGINS } from '@tinkoff/ng-event-plugins';
import { DraggableDirective } from './scrollbar/draggable.directive';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '/public/resources/i18n/', '.json');
}

@NgModule({ declarations: [
  FooterComponent,
  HeaderComponent,
  EditCustomerCarComponent,
  AddCarComponent,
  CustomFooterComponent,
  AlgoliaSelectorComponent,
  CatalogNavigationBoxComponent,
  TabsComponent,
  TabComponent,
  ModalComponent,
  ModalConfirmationComponent,
  AboutUsComponent,
  ViewDoShipmentDetailsComponent,
  FAQComponent,
  ContactUsComponent,
  WorkshopsApplicationComponent,
  CatalogSearchBoxComponent,
  VendorRegistrationComponent,
  SharedAuthComponent,
  StoreNewRequestComponent,
  MobileLoginComponent,
  CartComponent,
  ManualDispatchComponent,
  AddCustomerUserComponent,
  ScrollbarComponent
],
exports: [
  HeaderComponent,
  FooterComponent,
  CatalogSearchBoxComponent,
  EditCustomerCarComponent,
  TranslateModule,
  AddCarComponent,
  CustomFooterComponent,
  AlgoliaSelectorComponent,
  StoreNewRequestComponent,
  TabsComponent,
  TabComponent,
  ModalComponent,
  ModalConfirmationComponent,
  ToastrModule,
  FormsModule,
  CommonModule,
  ReactiveFormsModule,
  ComponentsModule,
  VendorRegistrationComponent,
  SharedAuthComponent,
  FormatTimePipe,
  MobileLoginComponent,
  CartComponent,
  CatalogNavigationBoxComponent,
  ManualDispatchComponent,
  AddCustomerUserComponent,
  ViewDoShipmentDetailsComponent,
  DndModule,
  AgGridModule,
  ScrollbarComponent
],
imports: [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  NgSelectModule,
  TranslateModule,
  ToastrModule.forRoot({ preventDuplicates: false }),
  TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory,
      deps: [HttpClient]
    }
  }),
  ComponentsModule,
  DndModule,
  AgGridModule,
  RouterModule.forChild(sharedModuleRoutes),
  ResizeObserverModule,
  FormatTimePipe,
  FocusDirective,
  DisableControlDirective,
  DraggableDirective
],
providers: [
  UntypedFormBuilder,
  RequestsCustomerService,
  CarsCustomerService,
  AlgoliaSearchService,
  ContentService,
  LookupService,
  CatalogsCustomerService,
  UsersService,
  S3Uploader,
  FormResetService,
  TeamCorePartsService,
  TeamCoreBrandsService,
  TeamCoreModelsService,
  TeamCoreCategoriesService,
  TeamCoreManufacturesService,
  SharedFormResetService,
  PaymentCustomerService,
  ProfileCustomerService,
  SharedFormResetService,
  QuickTranslateService,
  CarCustomerService,
  SharedCustomerService,
  TeamUsersService,
  // { provide: ErrorHandler, useFactory: errorHandlerFactory },
  WatchStorageService,
  ValidateVinService,
  NG_EVENT_PLUGINS,
  provideHttpClient(withInterceptorsFromDi())
] })
export class SharedModule {}